import { useCallback } from 'react';
import { useHref } from 'react-router-dom';

/** Links open the launcher first; authentication happens inside the new tab. */
export function useDoseSpotLinks(source: string) {
  const base = useHref('/jotrx');
  const query = useCallback(
    (onBehalfOfProviderId?: string): string => {
      const params = new URLSearchParams({ source });
      if (onBehalfOfProviderId) params.set('on_behalf_of_provider_id', onBehalfOfProviderId);
      return params.toString();
    },
    [source],
  );
  const getPatientHref = useCallback(
    (patientId: string, providerId?: string): string =>
      `${base}/prescribe-launch/${encodeURIComponent(patientId)}?${query(providerId)}`,
    [base, query],
  );
  const getClinicianHref = useCallback(
    (providerId?: string): string => `${base}/clinician-launch?${query(providerId)}`,
    [base, query],
  );
  return { getPatientHref, getClinicianHref };
}
